// Generated file : do not modify
import Dialog from '@/extend/classes/Dialog';
import { storeSession } from '@/generated/stores';
import { type AxiosResponse } from 'axios';
import ListData from '@/extend/classes/ListData';
import {getRequestConfig} from "@/framework/base/helpers/HttpHelper.ts";

// Gestion des fichiers
export class ExportType {
  // 
  public type: string;
  // 
  public extension: string;

  constructor() {
    this.type = '';
    this.extension = '';
  }
}

export class DownloadData {
  // 
  public service: string;
  // 
  public type: ExportType;
  // 
  public data: unknown;

  constructor() {
    this.service = '';
    this.type = new ExportType();
    this.data = null;
  }
}

export default class Files  {

  public static upload (data: FormData): Promise<Dialog> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/files/upload', data, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static download (data: DownloadData): Promise<string> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/files/download', data, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  // eslint-disable-next-line
  public static getDate(filess: Files[]) {
  }
}
